<template>
    <div :class="['sideNav','reveal',skinMode ==0 ? 'dots':'spread']">
        <ul>
            <li 
                v-for="(item, index) in sectionData.items" :key="index"
                @click="setItem(index)"
                :style="getCountAndIndexVars(index)"
                :class="[index==selectedIndex ? 'selected' : '']">
                    <span></span>
                    <span v-if="item[0]!=null && item[0].length>0">
                        {{localize(item[0])}}
                    </span>
            </li>
        </ul>
    </div>
</template>
<script>

import { mapActions, mapState } from "vuex";

export default {
    name: "sidepager",
    props: {
        skinMode:Number,
        itemIndex:Number,
        sectionIndex:Number        
    },
    data()
    {
        //sideDots
        //spreadLines
        return {
            sectionData:[],
            selectedIndex:0
        }
    },
    created()
    {
        //let _secIndex = Number(this.sectionIndex);
        this.sectionData = this.siteData.SECTIONS[this.sectionIndex];
    },
    watch:{
        itemIndex:function(newVal,oldVal){
            //alert("new = "+newVal);
            this.selectedIndex = Number(newVal);
        }
    },
    methods:
    {
      getCountAndIndexVars(index){
        return "--count:"+this.sectionData.items.length+";--index:"+index;
      },
        setItem(index)
        {
            //alert(index);
            this.selectedIndex = index;
            this.$emit('item-change',index);
        }
    },
    computed:{
      ...mapState(["siteData","siteDataReady"]),
    }
};
</script>

<style>
    .sideNav{
        width: 50px;
        padding: 20px;
    }
    .sideNav.spread
    {
        width: 100%;padding: 0px;
    }
    .sideNav ul{
        list-style: none;margin: auto;
    }

    .sideNav ul li{
        clear: both;padding: 6px 0px;cursor: pointer;
        position: relative;
    }
    .sideNav.spread ul li
    {
        clear: none;float: left;
        width: calc(100% / var(--count));
        padding: 0px 3px;
    }

    .sideNav ul li span:nth-child(1){
        width: 12px;height: 12px;
        opacity: 0;
        background-color: #40738d;
        border-radius: 40px;
        display: block;
        transition: all ease 0.3s;
        transform: scale(0.1) translateY(50px);
        transition-property: all;
        transition-duration: 0.8s;
        transition-timing-function: cubic-bezier(0.25, 0.46, 0.45, 0.94);
        transition-delay: calc(var(--index)*0.1s);
    }
    .sideNav.active ul li span:nth-child(1){
        background-color: #d8d8d8;
        transform: scale(1) translateY(0);
        opacity: 1;
    }



    .sideNav.spread ul li span:nth-child(1){
        width: 100%;height: 7px;
        border-radius: 0px;
    }

    .sideNav ul li.selected span:nth-child(1)
    {
        background-color: #40738d;
    }

    .sideNav.spread ul li span:nth-child(2)
    {
        display: none;
    }
    .sideNav ul li span:nth-child(2)
    {
        position:absolute;
        font-size: 11px;
        top: -1px;
        left: -8px;
        transform: translate(-100%,50%);
        width: 300px;
        text-align: right;
        pointer-events: none;
        opacity: 0;
        transition: all ease 0.3s;
    }

  @media (hover: hover) 
  {
    .sideNav ul li:hover span:nth-child(1)
    {
        background-color: #40738d;
    }
    .sideNav ul li:hover span:nth-child(2)
    {
        opacity: 1;
    }    

}    
</style>